import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import PwaPrompts from './components/pwa/PwaPrompts'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
    <PwaPrompts />
  </React.StrictMode>
)

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(
      new CustomEvent('logistiq:sw-update', { detail: registration })
    )
  },
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
